import {
    uploadProgressErrorCode,
    UploadProgressErrorPayload,
} from '../constants/uploadProgressError';

const NETWORK_ERROR_MARKERS = ['failed to fetch', 'networkerror', 'network request failed'];

interface GetUploadErrorTextOptions {
    defaultErrorText?: string;
    offlineErrorText?: string;
}

const isUploadProgressErrorPayload = (error: unknown): error is UploadProgressErrorPayload =>
    Boolean(
        error &&
            typeof error === 'object' &&
            'code' in error &&
            typeof (error as UploadProgressErrorPayload).code === 'string'
    );

export const isUploadAbortedError = (error: unknown): boolean => {
    if (isUploadProgressErrorPayload(error)) {
        return error.code === uploadProgressErrorCode.ABORTED;
    }

    return error instanceof DOMException && error.name === 'AbortError';
};

export const getUploadErrorText = (
    error: unknown,
    options: GetUploadErrorTextOptions = {}
): string => {
    const {
        defaultErrorText = '',
        offlineErrorText = 'Нет соединения с Интернетом',
    } = options;

    if (!error) {
        return defaultErrorText;
    }

    if (isUploadProgressErrorPayload(error)) {
        if (error.code === uploadProgressErrorCode.ABORTED) {
            return '';
        }
        if (error.code === uploadProgressErrorCode.NETWORK_FAILED) {
            return offlineErrorText;
        }
        if (error.code === uploadProgressErrorCode.SERVER_ERROR) {
            return (error.message || '').trim() || defaultErrorText;
        }
    }

    if (error instanceof TypeError) {
        return offlineErrorText;
    }

    if (typeof error === 'string') {
        const normalizedErrorText = error.trim();
        const lowerCaseErrorText = normalizedErrorText.toLowerCase();
        const isNetworkError = NETWORK_ERROR_MARKERS.some((marker) =>
            lowerCaseErrorText.includes(marker)
        );
        const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;

        if (isNetworkError || isOffline) {
            return offlineErrorText;
        }

        return normalizedErrorText || defaultErrorText;
    }

    if (error instanceof Error) {
        return error.message || defaultErrorText;
    }

    return defaultErrorText;
};
